import React, {Component} from 'react';

import {ReactComponent as DarkModeIcon} from "../../assets/icons/dark-and-light-mode/dark-mode.svg";
import {ReactComponent as LightModeIcon} from "../../assets/icons/dark-and-light-mode/light-mode.svg";
import './ThemeSelector.scss'
import PropTypes from "prop-types";

export class ThemeSelector extends Component{

    actualTheme = "";

    constructor(props) {
        super(props)
        this.actualTheme = localStorage.getItem("theme");
    }

    chooseTheme = () => {
        const newTheme = this.actualTheme === 'light' ? 'dark' : 'light';
        document.documentElement.dataset.bsTheme = newTheme;
        this.actualTheme = newTheme;
        this.props.changeTheme(newTheme)
    };

    render = () => (
        <div className="d-flex flex-row some-gap align-content-center">
            <div className="col-auto">
                <button className="button-no-style theme-toggle" onClick={this.chooseTheme}
                        aria-label={`Switch to ${this.actualTheme === 'light' ? 'dark' : 'light'} mode`}>
                    <div className="theme-toggle-icon-background">
                        <div className="theme-toggle-icon">
                            {this.actualTheme === 'light' ? <LightModeIcon aria-hidden="true" /> : <DarkModeIcon aria-hidden="true" />}
                        </div>

                    </div>
                </button>
            </div>
            <div className="col-auto theme-toggle-text">
                {this.actualTheme === 'light' ? "Light Mode" : "Dark Mode"}
            </div>
        </div>
    );
}

ThemeSelector.propTypes = {
    changeTheme: PropTypes.func.isRequired
}

export default ThemeSelector;